<template>
  <div class="big">
    <div class="page_title">用户数据明细</div>
    <div style="padding:20px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span class="item_title">数据类型</span>
            <el-select
              v-model="type"
              placeholder="请选择"
              style="width: 180px; "
              @change="search"
            >
              <el-option
                label="页面数据"
                value="page"
              ></el-option>
              <el-option
                label="点击数据"
                value="click"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="item_title">应用端口</span>
            <el-select
              v-model="platform"
              placeholder="请选择"
              style="width: 180px; "
              @change="search"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <div class="item">
            <span class="item_title">事件名称</span>
            <el-input
              v-model="key_name"
              style="width: 180px; "
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="item_title">页面名称</span>
            <el-input
              v-model="point_name"
              style="width: 180px;"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="item_title">关联数据</span>
            <el-input
              v-model="business_name"
              style="width: 180px;"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="item_title">推荐/分享人</span>
            <el-input
              v-model="share_name"
              style="width: 180px; "
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="item_title">统计时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              style="width: 230px; margin-right:10px"
              @change="search"
            >
            </el-date-picker>
            <el-button
              type="info"
              style="background-color: #eceff2; color: #747981"
              @click="search"
            >查询</el-button>
          </div>
        </div>
        <div style="text-align:right;margin-bottom:10px">
          <el-button
            size="medium"
            type="primary"
            style="width:100px"
            @click="excelexport"
            :disabled="
                  module_id_array[0] ? !module_id_array.includes('1029') : false
                "
          >导出</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="create_time"
              label="时间"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="key_name"
              label="事件名称"
            >
            </el-table-column>
            <el-table-column
              prop="buried_point_name"
              label="页面名称"
            ></el-table-column>
            <el-table-column
              prop="platform"
              label="应用端口"
            ></el-table-column>
            <el-table-column
              label="前置页面"
              prop="front_page_name"
            >
            </el-table-column>
            <el-table-column
              prop="business_name"
              label="关联数据"
            >
            </el-table-column>
            <el-table-column
              prop="device_id"
              label="设备id"
            >
            </el-table-column>
            <el-table-column
              prop="key_name"
              label="用户信息"
            >
              <template slot-scope="scope">
                <div>
                  <span style="margin-right:10px">{{scope.row.real_name}}</span> <span
                    v-if="scope.row.sex==1"
                  >男</span>
                  <span v-if="scope.row.sex==2">女</span>
                </div>
                <div>
                  {{scope.row.phone}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="openid"
              label="小程序openid"
            >
            </el-table-column>
            <el-table-column
              prop="area"
              label="区域"
            >
            </el-table-column>
            <el-table-column label="推荐/分享人">
              <template slot-scope="scope">
                <div>
                  {{scope.row.share_name}}
                </div>
                <div>
                  {{scope.row.share_phone}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.user_id"
                  @click="toDetail(scope.row.user_id)"
                  type="text"
                  :disabled="module_id_array[0]?!module_id_array.includes('41'):false"
                >用户详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import _ from 'lodash';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      page_id: '',
      type: 'page',
      platform: '',
      business_name: '',
      platform: '',
      key_name: '',
      point_name: '',
      share_name: '',
      date: [],
      options: [
        {
          value: 'ios',
          label: 'ios'
        },
        {
          value: 'android',
          label: '安卓'
        },
        {
          value: 'shopapplet',
          label: '商城小程序'
        },
        {
          value: 'applet',
          label: '诊疗小程序'
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        page_id: this.page_id,
        click_id: this.click_id,
        type: this.type,
        platform: this.platform,
        business_name: this.business_name,
        key_name: this.key_name,
        share_name: this.share_name,
        point_name: this.point_name
      };
      if (this.date && this.date.length) {
        data.start_time = this.date[0];
        data.end_time = this.date[1];
      }
      this.axios.post('platform/Buried/buriedPointDetail', data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm:ss');
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //详情
    toDetail(user_id) {
      if (!user_id) {
        return false;
      }
      this.$router.push({
        path: '/home/patient/userdetail',
        query: { user_id }
      });
    },
    //导出数据
    excelexport() {
      let loading = this.$loading();
      let data = {
        page_id: this.page_id,
        click_id: this.click_id,
        type: this.type,
        platform: this.platform,
        business_name: this.business_name,
        key_name: this.key_name,
        share_name: this.share_name
      };
      if (this.date && this.date.length) {
        data.start_time = this.date[0];
        data.end_time = this.date[1];
      }
      this.axios
        .post('platform/Buried/exportBuriedPointDetail', data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              '//' +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    }
  },
  activated() {
    if (this.$route.query.page_id) {
      this.type = '';
      this.click_id = '';
      this.page_id = this.$route.query.page_id;
      this.point_name = this.$route.query.buried_point_name;
      this.date = JSON.parse(this.$route.query.date);
      switch (this.$route.query.platform) {
        case 'ios':
          this.platform = 'ios';
          break;
        case '安卓':
          this.platform = 'android';
          break;
        case '商城小程序':
          this.platform = 'shopapplet';
          break;
        case '诊疗小程序':
          this.platform = 'applet';
          break;
      }
      this.getList();
    } else if (this.$route.query.click_id) {
      this.type = '';
      this.page_id = '';
      this.click_id = this.$route.query.click_id;
      this.key_name = this.$route.query.key_name;
      this.point_name = this.$route.query.buried_point_name;
      this.date = JSON.parse(this.$route.query.date);
      switch (this.$route.query.platform) {
        case 'ios':
          this.platform = 'ios';
          break;
        case '安卓':
          this.platform = 'android';
          break;
        case '商城小程序':
          this.platform = 'shopapplet';
          break;
        case '诊疗小程序':
          this.platform = 'applet';
          break;
      }
      this.getList();
    } else {
      this.type = 'page';
      this.page_id = '';
      this.click_id = '';
      this.key_name = '';
      this.point_name = '';
      this.platform = '';
      this.date = [];
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .item {
    margin-bottom: 14px;
    margin-right: 40px;
  }
  .item_title {
    display: inline-block;
    width: 80px;
    text-align: left;
  }
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 300px;
  padding-top: 20px;
  margin-bottom: 20px;
}
.content {
  padding: 20px;
  text-align: left;
  .box {
    background: #f5f5f5;
    margin-top: 8px;
    padding: 10px;
  }
  .green {
    color: #669961;
    font-weight: 700;
    margin-top: 20px;
  }
  .title {
    font-weight: 700;
    margin-bottom: 6px;
  }
  .item {
    margin-bottom: 14px;
  }
  .pricebox {
    display: flex;
    align-items: center;
    padding: 15px 0;
    box-sizing: border-box;
    .priceitem {
      text-align: center;
      padding: 0 20px;
      border-right: solid 1px #d6d6d6;
    }
    .priceitem:before {
      content: '';
    }
    .gray {
      font-size: 12px;
      color: #747981;
      display: inline-block;
      width: 60px;
    }
    .num {
      font-size: 18px;
      font-weight: 600;
    }
    .red {
      color: #f24e33;
    }
  }
}
</style>